import React from 'react'
import { StyleSheet, View, LogBox, Platform, Image } from 'react-native'
import AsyncStorage from '@react-native-async-storage/async-storage'
// import SplashScreen from 'react-native-splash-screen'

import delay from 'delay'

import client from '@sart/client'
import { CompanyIcon } from '@sart/icons'
import { colors, backgroundColors, adaptive } from '@sart/styles'

import AppConfig from './Configuration'

export default class AppLoadingScreen extends React.Component {
  componentDidMount() {
    if (Platform.OS === "ios" || Platform.OS === "android") {
      // SplashScreen.hide();
    }

  }
  constructor(props) {
    super(props)
    this._loadAsync()
  }

  async _loadAsync() {
    try {
      //LogBox.ignoreLogs(['Warning: ...']); // Ignore log notification by message
      //LogBox.ignoreAllLogs();//Ignore all log notifications
      LogBox.ignoreLogs(['Animated: `useNativeDriver`'])
      await this._loadAssetsAsync()
      await this._bootstrapAsync()
    } catch (error) {
      console.error(error.message)
    }
  }

  async _loadAssetsAsync() {
    try {
      /*await Font.loadAsync({
        'open-sans-light': require('../assets/fonts/OpenSans-Light.ttf'),
        'open-sans-regular': require('../assets/fonts/OpenSans-Regular.ttf'),
        'open-sans-semibold': require('../assets/fonts/OpenSans-SemiBold.ttf'),
        'open-sans-bold': require('../assets/fonts/OpenSans-Bold.ttf')
      }) */
    } catch (error) {
      // console.warn(
      //   'There was an error caching assets (see: main.js), perhaps due to a ' +
      //     'network timeout, so we skipped caching. Reload the app to try again.'
      // )
      // console.log(error.message)
    }
  }

  // From: https://reactnavigation.org/docs/en/auth-flow.html
  // Fetch the token from storage then navigate to our appropriate place
  _bootstrapAsync = async () => {
    await delay(1000)

    // This will switch to the App screen or Auth screen and this loading
    // screen will be unmounted and thrown away.

    try {
      AppConfig.logoutFunction = this.logoutFunction
      client.setConfiguration(AppConfig)
      client.setApiBasePath(client.configuration.basePath)
      client.setHeaders({ Version: client.configuration.apiVersion })
      client.cache.language = AppConfig.defaultLanguage
      await client.testServerIsAvailable()

      //TODO this should be client.signInWithStoredTokenNoSync
      const auth = await client.signInWithStoredTokenNoSync()

      const lastLoginDate = await AsyncStorage.getItem('lastLoginDate')
      console.log('lastLoginDate', lastLoginDate)
      const today = new Date()
      const lastVisitedToday = lastLoginDate === today.toDateString()
      if (auth && auth.token && lastVisitedToday) {
        this.props.navigation.navigate('Main')
      } else {
        //Unauthenticated
        if (this.props.navigation.getState().routes.length === 1) {
          //Initial load, go to Registration Home
          this.props.navigation.navigate('Sign', { screen: 'SignIn' })
        }
        //If the route is longer, it's not an inial log in, so just carry onto the screen they are navigating to
      }
    } catch (error) {
      console.log(error)
      if (error.status === 405) {
        this.props.navigation.navigate('Unavailable')
      } else {
        if (error.status === 403) {
          await client.signOutAndForget()
        }

        this.props.navigation.navigate('Sign', { screen: 'SignIn' })
      }
    }
  }

  logoutFunction = async () => {
    await client.signOutAndForget()
    this.props.navigation.navigate('Sign')
  }

  // Render any loading content that you like here
  render() {
    return (
      <View style={styles.container}>
        {/* <CompanyIcon color={colors.white} height={styles.logoStyle.height} width={styles.logoStyle.width} /> */}
        <Image
          source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
          height={styles.logoStyle.height} width={200} alignSelf={"center"}
        />
      </View>
    )
  }
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: backgroundColors.darkCharcoal,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24
  },
  logoStyle: {
    color: colors.white,
    ...adaptive.logoSplashScreenSize
  }
})
